import styled from 'styled-components'
import { grayLight } from '@bufferapp/ui/style/colors'

export const Image = styled.img`
  background-color: ${grayLight};
  border-radius: 50%;
  width: 100%;
  height: 100%;
  display: block;
  user-select: none;
`
